module.exports = __webpack_public_path__ + "img/zhendong1.gif";